import { Color3 } from "@babylonjs/core/Maths/math.color";
import { Mesh } from "@babylonjs/core/Meshes/mesh";
import { CreateLines } from "@babylonjs/core/Meshes/Builders/linesBuilder";
import { ExtrudeShape } from "@babylonjs/core/Meshes/Builders/shapeBuilder";
import { Vector2, Vector3 } from "@babylonjs/core/Maths/math.vector";
import { CreateLineSystem } from "@babylonjs/core/Meshes/Builders/linesBuilder";
import { CsgUtils } from "../CsgUtils";
import { ElementGeometry } from "./ElementGeometry";
import { Util } from "../../utils/Util";
import { ShadowGenerator } from "@egr/wcf/modules/core/rendering/ShadowGenerator";
export class SafetyZone extends ElementGeometry {
    constructor(pRoomManager, pElement) {
        super(pRoomManager, pElement);
        this.mRoomElement = pElement;
        this.mRoomManager = pRoomManager;
        this.mPoints = new Array();
        this.mCutPoints = new Array();
        this.mFreeSpacePoints = new Array();
        this.mWidth = 0;
        this.mDepth = 0;
        this.mMaterial = 0;
        this.mColor = "#999999";
        this.mCenter = Vector3.Zero();
        this.mminPoint = Vector3.Zero();
        this.mmaxPoint = Vector3.Zero();
        this.mArea = 0;
        this.mPerimeter = 0;
        this.mClosedPolygon = true;
        this.mRoomElement.Params.ElementPoints = new Array();
        this.mRoomElement.Params.ElementOriginalPoints = new Array();
        this.mRoomElement.Params.material = this.mRoomElement.material;
        this.mRoomElement.Params.materialColor = this.getInitialParams().color;
    }
    getType() {
        return ("SafetyZone");
    }
    setMesh(pMesh) {
        this.mArea = Util.calcMeshArea(pMesh) * 0.25;
    }
    get drawnMesh() {
        return (this.mMesh2d);
    }
    getPoints() {
        let tRes = new Array();
        let tNPos = this.mRoomElement.node.absolutePosition;
        for (let tP of this.mPoints) {
            let tnP = tP.add(tNPos).clone();
            tRes.push(tnP);
        }
        return (tRes);
    }
    getPolygon(pOffset = true) {
        let tpolygonPoints = [];
        let tsplinePoints = this.mPoints;
        let tnodePos = new Vector3(0, 0, 0);
        let tME = this.mRoomElement.getMainElement();
        if (tME != null && pOffset) {
            tnodePos = this.mRoomElement.node.position.clone();
        }
        for (let tP of tsplinePoints) {
            let tnP = tP.add(tnodePos);
            tpolygonPoints.push(tnP);
        }
        return (tpolygonPoints);
    }
    getSZFreeSpacePoints() {
        let tFSpoints = new Array();
        for (let tPolygon of this.mFreeSpacePoints) {
            let tnewPolygon = new Array();
            for (let tPoint of tPolygon) {
                let tnewPoint = new Vector2(0, 0);
                tnewPoint.x = tPoint.x;
                tnewPoint.y = tPoint.z;
                tnewPolygon.push(tnewPoint);
            }
            tFSpoints.push(tnewPolygon);
        }
        return (tFSpoints);
    }
    width() {
        return this.mWidth;
    }
    depth() {
        return this.mDepth;
    }
    material() {
        return this.mMaterial;
    }
    center() {
        return this.mCenter;
    }
    minPoint() {
        return this.mminPoint;
    }
    maxPoint() {
        return this.mmaxPoint;
    }
    showInteractors(pShow) {
        //if (this.mInteractors != null)
        //    this.mInteractors.showInteractors(pShow);
    }
    correctDirection() {
        let tClockwise = Util._clockWise3(this.mPoints);
        if (tClockwise)
            this.mPoints.reverse();
    }
    getInitialParams() {
        let tParams = {};
        tParams.width = 0.5;
        tParams.height = 0;
        tParams.floorOffset = 0.0;
        tParams.color = this.mColor;
        return (tParams);
    }
    getparent() {
        return (this.mParent);
    }
    get Area() {
        return (this.mArea);
    }
    get Perimeter() {
        return (this.mPerimeter);
    }
    getLines() {
        let tRes = new Array();
        for (let i = 0; i < this.mRoomElement.Params.ElementPoints.length - 1; i++) {
            tRes.push([this.mRoomElement.Params.ElementPoints[i], this.mRoomElement.Params.ElementPoints[i + 1]]);
        }
        return (tRes);
    }
    clearCutPoints() {
        this.mCutPoints = [];
        this.mCutPoints.push(this.mPoints);
    }
    create2dGeometry(pParent) {
        this.mParent = pParent;
        let tLine = this.createSafetyZone(pParent);
        //this.createFreespaceLine(pParent);
        if (tLine != null) {
            this.mRoomElement.setMesh2d(tLine);
        }
    }
    create3dGeometry(pParent) {
        let tLine = this.createSafetyZone(pParent);
        //this.createFreespaceLine(pParent);
        if (tLine != null) {
            this.mRoomElement.setMesh3d(tLine);
        }
    }
    createSpecialGeometry(pParent) {
        this.createPerimeterLine(pParent);
        this.createFreespaceLine(pParent);
    }
    serializeIOData() {
        return (this.mRoomElement.Params);
    }
    loadIOData(pData) {
        let tParams = pData;
        let tPoints = new Array();
        for (let tEP of tParams.ElementPoints) {
            let tP = new Vector3(0, 0, 0);
            tP.x = tEP.x;
            tP.z = tEP.z;
            tPoints.push(tP);
        }
        this.setPoints(tPoints);
    }
    setPoints(pPoints) {
        this.mPoints = [];
        for (let tPoint of pPoints) {
            let tP = new Vector3(0, 0, 0);
            tP.x = tPoint.x;
            tP.z = tPoint.z;
            this.mPoints.push(tP);
        }
        this.checkClosedPolygon();
        if (this.mClosedPolygon)
            this.correctDirection();
        this.mRoomElement.Params.ElementPoints = this.mPoints;
        this.calcCenter();
        this.calcSize();
    }
    setFreeSpacePoints(pPolygons) {
        this.mFreeSpacePoints = [];
        for (let tPolygon of pPolygons) {
            let tnewPolygon = new Array();
            for (let tPoint of tPolygon) {
                let tP = new Vector3(0, 0, 0);
                tP.x = tPoint.x;
                tP.z = tPoint.y;
                tnewPolygon.push(tP);
            }
            let tClockwise = Util._clockWise3(tnewPolygon);
            if (tClockwise)
                tnewPolygon.reverse();
            this.mFreeSpacePoints.push(tnewPolygon);
        }
    }
    checkClosedPolygon() {
        this.mClosedPolygon = Util.vectorEquals3(this.mPoints[0], this.mPoints[this.mPoints.length - 1]);
        this.mRoomElement.setClosedPolygon(this.mClosedPolygon);
    }
    calcCenter() {
        let t2dPoints = new Array();
        for (let tP of this.mPoints)
            t2dPoints.push(new Vector2(tP.x, tP.z));
        let tCenter = new Vector3(0, 0, 0);
        if (this.mPoints.length > 2)
            tCenter = Util.getPolygonCentroid(t2dPoints);
        else {
            tCenter = Vector3.Center(this.mPoints[0], this.mPoints[1]);
        }
        this.mCenter = tCenter;
    }
    calcSize() {
        if (this.mPoints.length === 0)
            return;
        let tminX = this.mPoints[0].x;
        let tminY = this.mPoints[0].z;
        let tmaxX = this.mPoints[0].x;
        let tmaxY = this.mPoints[0].z;
        for (let tPoint of this.mPoints) {
            tminX = Math.min(tPoint.x, tminX);
            tmaxX = Math.max(tPoint.x, tmaxX);
            tminY = Math.min(tPoint.z, tminY);
            tmaxY = Math.max(tPoint.z, tmaxY);
        }
        this.mWidth = tmaxX - tminX;
        this.mDepth = tmaxY - tminY;
        this.mRoomElement.setWidth(this.mWidth, false);
        this.mRoomElement.setDepth(this.mDepth, false);
        this.mminPoint = new Vector3(tminX, 0, tminY);
        this.mmaxPoint = new Vector3(tmaxX, 0, tmaxY);
        this.calcLenght();
    }
    calcLenght() {
        let tDist = 0;
        for (let i = 1; i < this.mRoomElement.Params.ElementPoints.length; i++) {
            tDist += Vector3.Distance(this.mPoints[i - 1], this.mRoomElement.Params.ElementPoints[i]);
        }
        this.mPerimeter = tDist;
        //this.mRoomElement.setPerimeter(this.mPerimeter);
    }
    drawOutline(pParent) {
        //for invisible picking plane
        let tpickShape = [
            new Vector3(-0.5, 0, 0.5),
            new Vector3(-0.5, 0, -0.5),
            new Vector3(0.5, 0, -0.5),
            new Vector3(0.5, 0, 0.5),
            new Vector3(-0.5, 0, 0.5)
        ];
        if (this.mRoomElement.material === -1) {
            let tLines = CreateLines("", { points: this.mRoomElement.Params.ElementPoints }, this.mScene);
            tLines.color = Color3.FromHexString("#000000");
            tLines.parent = pParent;
            tLines.isPickable = false;
            tLines.renderingGroupId = 1;
            ShadowGenerator.disableMeshShadow(tLines);
            this.prepare3dMesh(tLines);
        }
        let tpolygon = ExtrudeShape("", { shape: tpickShape,
            path: this.mRoomElement.Params.ElementPoints,
            sideOrientation: Mesh.DOUBLESIDE,
            updatable: true }, this.mScene);
        tpolygon.isPickable = true;
        tpolygon.parent = pParent;
        tpolygon.visibility = 0;
        ShadowGenerator.disableMeshShadow(tpolygon);
        this.prepare3dMesh(tpolygon);
        return (tpolygon);
    }
    createCSG() {
        let tP = this.getPolygon(false);
        tP.pop();
        let tPoints = new Array();
        for (let tPnt of tP) {
            tPoints.push(new CSG.Vector2D(tPnt.x, tPnt.z));
        }
        let tCAGshape = CAG.fromPointsNoCheck(tPoints);
        if (!tCAGshape.isSelfIntersecting()) {
            this.mRoomElement.setCAG(tCAGshape);
            let tCSG = Util.CAG2CSG(tCAGshape);
            let tMeshes = CsgUtils.buildMeshes(tCSG, this.mScene);
            if (tMeshes == null)
                return (null);
            for (let tMesh of tMeshes) {
                tMesh.name = "shape2d_safetyzone";
                ShadowGenerator.disableMeshShadow(tMesh);
                tMesh.material = this.mRoomElement.localMaterial;
                tMesh.visibility = this.mRoomElement.get_SafetyZone_Visibility() ? 1 : 0;
            }
            this.mRoomElement.setArea(tCAGshape.area());
            return (tMeshes[0]);
        }
        return (null);
    }
    createSafetyZone(pParent) {
        if (this.mPoints.length === 0)
            return (null);
        if (this.mClosedPolygon) {
            let tMesh = this.createCSG();
            if (tMesh == null)
                return (null);
            if (this.mRoomElement.status === "Transform") {
                tMesh.renderingGroupId = 1;
                tMesh.visibility = 0.5;
            }
            if (this.mRoomElement.status === "") {
                tMesh.visibility = 1;
            }
            ShadowGenerator.disableMeshShadow(tMesh);
            tMesh.parent = pParent;
            return (tMesh);
        }
        return (this.drawOutline(pParent));
    }
    createPerimeterLine(pParent) {
        let tOL = this.mRoomElement.getOutlines();
        if (tOL.length === 0)
            return;
        let tLines = CreateLineSystem("safetyzone_outline", { lines: tOL }, this.mScene);
        tLines.parent = pParent;
        tLines.renderingGroupId = 1;
        this.mRoomManager.app.model.layers.setMeshLayer(tLines, "room:PerimeterLine_Layer");
        tLines.color = Color3.FromHexString("#000000");
        ShadowGenerator.disableMeshShadow(tLines);
        if (this.mRoomElement.CAGoriginal === null)
            return;
        let tOL_original = this.mRoomElement.getOutlinesOfCAG(this.mRoomElement.CAGoriginal);
        let tLines_original = CreateLineSystem("safetyzone_outlineOriginal", { lines: tOL_original }, this.mScene);
        tLines_original.parent = pParent;
        tLines_original.renderingGroupId = 1;
        this.mRoomManager.app.model.layers.setMeshLayer(tLines_original, "room:PerimeterLineOriginal_Layer");
        tLines_original.color = Color3.FromHexString("#000000");
        ShadowGenerator.disableMeshShadow(tLines_original);
    }
    createFreespaceLine(pParent) {
        for (let tFS_CAG of this.mRoomElement.CAG_FS) {
            let tOL = this.mRoomElement.getOutlinesOfCAG(tFS_CAG);
            let tLines = CreateLineSystem("safetyzone_FreeSpace", { lines: tOL }, this.mScene);
            tLines.parent = pParent;
            tLines.renderingGroupId = 1;
            this.mRoomManager.app.model.layers.setMeshLayer(tLines, "room:FreeSpaceLine_Layer");
            tLines.color = Color3.FromHexString("#FF0000");
            ShadowGenerator.disableMeshShadow(tLines);
        }
    }
}
